
import { Component, Prop, Vue } from 'vue-property-decorator'
import { v4 as uuidv4 } from 'uuid'

import Bus from '@/utils/bus'

@Component
export default class UserVoice extends Vue {
  @Prop()
  item!: any

  private isPlay = false
  readonly uuid = uuidv4()
  readonly audio = new Audio()

  mounted () {
    Bus.$on('stopAll', (uuid: string) => {
      if (uuid !== this.uuid) {
        this.audio.pause()
      }
    })

    this.audio.onplay = () => {
      Bus.$emit('stopAll', this.uuid)
      this.isPlay = true
    }
    this.audio.onpause = () => {
      this.isPlay = false
    }
  }

  beforeDestroy() {
    Bus.$off('stopAll')
  }

  playToggle () {
    if (!this.isPlay) {
      this.audio.src = window.URL.createObjectURL(this.item.content.blob)
      this.audio.play()
    } else {
      this.audio.pause()
    }
  }
}
